import React from "react";
import hostMap from "../../hostMap";
import WujieReact from "wujie-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { loginInfo } from "../../utils";

export default function FinaGridPvMeterMgrCzxnyPage() {
  const location = useLocation();
  const navigation = useNavigate();
  const childUrl = hostMap("//localhost:3914/");
  const path = location.pathname;
  const { tenantId, staId } = useSelector(state => state.user);

  const props = {
    token: localStorage.getItem("saas-token"),
    tenantId: tenantId,
    stationId: staId,
    menuType: 1,
    jump: (name) => {
      navigation(`/${name}`);
    },
    method: { loginInfo }
  };

  return (
    <WujieReact
      width="100%"
      height="100%"
      name="basic"
      url={childUrl}
      sync={!path}
      props={props}
      degrade={true}
    ></WujieReact>
  );
}
